// Lightweight shimmer placeholder for next/image `placeholder="blur"` on remote
// images (where we have no static import to generate a blurDataURL from).
const shimmer = (w: number, h: number) => `
<svg width="${w}" height="${h}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <defs>
    <linearGradient id="g">
      <stop stop-color="#f0f2f5" offset="20%" />
      <stop stop-color="#e5e8f0" offset="50%" />
      <stop stop-color="#f0f2f5" offset="70%" />
    </linearGradient>
  </defs>
  <rect width="${w}" height="${h}" fill="#f0f2f5" />
  <rect id="r" width="${w}" height="${h}" fill="url(#g)" />
  <animate xlink:href="#r" attributeName="x" from="-${w}" to="${w}" dur="1.2s" repeatCount="indefinite" />
</svg>`;

const toBase64 = (str: string) =>
  typeof window === 'undefined'
    ? Buffer.from(str).toString('base64')
    : window.btoa(str);

export const shimmerDataURL = (w = 700, h = 475) =>
  `data:image/svg+xml;base64,${toBase64(shimmer(w, h))}`;

// Sizes hint for the shop grid: tiles are `minmax(350px, 1fr)` (2-up under 460px).
export const SHOP_TILE_SIZES =
  '(max-width: 460px) 50vw, (max-width: 1024px) 45vw, 400px';
